<div class="d-flex align-items-center" [class.flex-fill]="flexFill" data-test-id="scan-tool-switcher">
  <ds-input [label]="'testing_tool' | translate" [state]="DsInputStates.inline" [class.flex-fill]="flexFill">
    <select ds-input-field [(ngModel)]="currentValue" (ngModelChange)="onToolSelect($event)">
      @for (auditToolName of toolsToList; track $index) {
        <option [value]="auditToolName">
          {{ 'scan_results_tool_option_' + auditToolName | translate }}
        </option>
      }
    </select>
  </ds-input>
</div>
